<template>
  <avz-categories />
</template>

<script>
import Categories from '@/components/Categories'

export default {
  components: {
    'avz-categories': Categories
  }
}
</script>
